export const characters = /^(?=.*[A-Za-z])[a-zA-Z0-9'\-_. ]+(?:\s[a-zA-Z0-9'_\-. ]+)*$/;
export const namePattern = /^[A-Za-z\s]+$/; // This is fine
export const pinFormat = /^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/; // This is fine
export const postCode = /^((0[289]\d{2})|([1-9]\d{3}))$/; // This is fine
export const customEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,3}$/i; // This is fine
export const format = /^(?:\+61)? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d{2}[- ]?\d{3}[- ]?\d{3})$/; // This is fine
export const generalPhoneNumber = /^(?=.*\d)[+\d\s-]+$/;
export const posportVisa = /^[A-Z0-9]{8,13}$/; // This is fine
export const linkedinProfileUrl = /^((https?:\/\/)?(www\.)?linkedin\.com[/\w#?=-]+)$/; // This is fine
export const firstnameVar = / *\{[firstname]*\} */g;
export const lastnameVar = / *\{[lastname]*\} */g;
export const yearRegex = /^(19|20)\d{2}$/; // This is fine
export const numberRegex = /^[0-9\b]+$/; // This is fine

// Free text with no HTML and no links. Mirrors the backend JobApplicationGuard::plainTextRule.
export const noMarkupOrLinks = /^(?![\s\S]*(?:[<>]|\b(?:https?|ftp|javascript|data):|\bwww\.))[\s\S]*$/i;
// Anything that looks like an HTML tag ("<5 years" is fine). Mirrors JobApplicationGuard::HTML_TAG_REGEX.
export const htmlTagPattern = /<\s*\/?\s*[a-z!?]/i;

//allow alphanumeric and .#!@$
export const keywordRuleset =/^[ A-Za-z0-9.#!@$]*$/;

export const supportFormat = [
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "application/pdf", // .pdf
    // "application/vnd.oasis.opendocument.text", // .odt
    // "text/html", // .html
    // "text/htm", // .htm
    "text/plain", // .txt
    "application/rtf", // .rtf
    // "image/vnd.ms-modi", //.mdi - type not noticed
    "mdi", //mdi - working
];


export const allowedFilesForOptionThree = [
    {
        "fileType": ".doc",
        "fileVal": "application/msword"
    },
    {
        "fileType": ".docx",
        "fileVal": "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    },
    {
        "fileType": ".pdf",
        "fileVal": "application/pdf"
    },
    {
        "fileType": ".txt",
        "fileVal": "text/plain"
    },
    {
        "fileType": ".rtf",
        "fileVal": "application/rtf"
    },
    {
        "fileType": ".mdi",
        "fileVal": "mdi"
    }
];

export const FileSize = 2097152;
export const defaultFileSize = 2;



